module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-end-circle-1728e139.svg";